// PMS list endpoints page-size defaults to 5000. Some partners exceed that on multiple
// asset types, so list calls override with this higher size. Single source of truth.
export const ASSET_LIST_PAGE_SIZE = 8000;
